import React,{useState} from 'react'
import Lightbox from 'yet-another-react-lightbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import 'yet-another-react-lightbox/styles.css';
import { PageTitle } from '../../../../../_template/layout/core/PageData';
import SAISVG from '../../../../../_template/helpers/CommonFunction';
import { toAbsoluteUrl } from '../../../../../_template/helpers/CommonFunction';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
const WidgetIntegration = () => {
    const loginUserType = localStorage.getItem('type');

    let botSetupHomeTitle = [];
    if(loginUserType === 'A'){
        botSetupHomeTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
            {
                title: 'Guide',
                path: '/guide/overview',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    else if(loginUserType === 'D'){
        botSetupHomeTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }

    const inregrationImgArr = [
        { src: toAbsoluteUrl('saiFile/widgetIntegration/img_1.jpg') },
    ];

    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const htmlFormat = `
        <!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Chat Widget Example</title>
            </head>
            <body>
                <h1>Welcome to My Website</h1>
                <p>The chat widget will appear in the corner of this page.</p>
                <script 
                    src="https://demo.example.com/public/chatwidget/js/chatWidget.js" 
                    bizcode="YnV0dGVy" 
                    auth="DFHBGFT554JHGG" 
                    id="secured" 
                    widget="HBGH525KJ==">
                </script>
            </body>
        </html>
    `;

    const copyHtmlFormat = async() => {
       await navigator.clipboard.writeText(htmlFormat);
        toast.success("Successfully copied");
    }

    return (
        <>
            <PageTitle breadcrumbs={botSetupHomeTitle}>Widget Integration</PageTitle>
            <div className="row">
                <div className="col-md-12 col-12">
                    <div className="card card-flush border">
                        <div className="card-header mt-5">
                            <div className="card-title align-items-start flex-column">
                                <h2 className="card-label fw-bold text-gray-800 fs-3x mb-4">
                                    Widget Integration Guide
                                </h2>
                                <span className="text-gray-800 mt-2 fw-bold fs-1x mb-4 ">
                                    This guide will help you integrate the chat widget into your website in just a few steps.
                                </span>
                            </div>
                        </div>
                        <div className="card-body pt-2">
                            <div id="overview">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Overview
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                                                The chat widget allows your users to interact with your bot directly from your website.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Each bot comes with a unique Integration Script that you can copy and paste into your site.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Get Your Integration Script
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                                                Go to the <span className='fw-bold'>Truchat Widget</span> page.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Locate the Integration Script for your bot.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Copy the script.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3 mb-4">
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={inregrationImgArr[0].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(0) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Add the Script to Your Website
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                                                Inside the <code>&lt;head&gt;</code> section, or
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Just before the closing <code>&lt;body&gt;</code> tag.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3 mb-4">
                                            <div className='text-end'>
                                                <Tooltip title="Click to copy the script">
                                                    <FontAwesomeIcon 
                                                        icon={faCopy} 
                                                        className='fs-2 text-gray-600'
                                                        onClick={copyHtmlFormat}
                                                    />
                                                </Tooltip>
                                            </div>
                                            <pre className="bg-gray-100 p-4 rounded-lg overflow-x-auto text-left whitespace-pre-wrap fs-5">
                                                <code>
                                                    {
                                                        htmlFormat
                                                    }
                                                </code>
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Security Best Practices
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                                                Do not share your integration script publicly.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                                <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Only paste it into websites you own or manage.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[inregrationImgArr[currentIndex]]}
                currentIndex={currentIndex}
                carousel={{ finite: true }}
            />
        </>
    )
}

export default WidgetIntegration